import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { historyActions } from 'src/ducks/actions'
import { getJobHistoryStatus } from 'src/ducks/history/selectors'
import { getJob } from 'src/ducks/selectors'
import { ROWS_PER_PAGE_SIMPLE } from 'src/helpers'
import headers from './headers'

const Status = ({ id }: { id?: string }) => {
  const dispatch = useDispatch()
  
  const jobHistoryStatus = useSelector(getJobHistoryStatus)
  const job = useSelector(getJob())
  
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(50)
  const [historyRecords, setHistoryRecords] = useState(jobHistoryStatus)

  useEffect(() => {
    updatePage()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size, jobHistoryStatus])

  const updatePage = () => {
    const start = page * size
    const end = start + size > jobHistoryStatus.length ? jobHistoryStatus.length : start + size

    setHistoryRecords(jobHistoryStatus.slice(start, end))
  }

  const fetchJobHistoryStatus = useCallback(() => {
    if (id) {
      dispatch(
        historyActions.fetchHistoryStatus(id, (_succ: boolean) => {
          setLoading(false)
        })
      )
    }
  }, [dispatch, id])

  useEffect(() => {
    fetchJobHistoryStatus()
  }, [fetchJobHistoryStatus, job])

  return (
    <Table
      headers={headers}
      title="STATUS HISTORY"
      loading={loading}
      small
      totalItems={jobHistoryStatus.length}
      rowsPerPageDefault={50}
      rowsPerPageOptions={ROWS_PER_PAGE_SIMPLE}
      callToApi={(start, limit) => {
        setPage(start)
        setSize(limit)
      }}
      hasTopPagination
      hasPagination={false}
    >
      {historyRecords}
    </Table>
  )
}

export default Status;